import type {
  CancelPolicyApiComponentBlock,
  CancelPolicyApiResponse,
  CancelPolicyNormalized,
  CancelPolicyPageData,
} from "../types";

/**
 * Shape we expect at each nesting level after unwrapping the
 * variable-depth backend envelope (`data`, `data.data`, etc.).
 * SSR passes `apiResponse.data.data`; client `getCancelPolicyDetails`
 * returns `response.data`, which may still be wrapped.
 */
interface DataNode {
  components?: unknown;
  pageData?: CancelPolicyPageData;
  bookingId?: string;
  data?: DataNode;
}

const asComponents = (value: unknown): CancelPolicyApiComponentBlock[] =>
  Array.isArray(value) ? (value as CancelPolicyApiComponentBlock[]) : [];

export const normalizeCancelPolicy = (
  raw?: CancelPolicyApiResponse
): CancelPolicyNormalized => {
  const typedRaw = (raw ?? {}) as DataNode;

  const root: DataNode = typedRaw?.data?.components
    ? typedRaw
    : typedRaw?.data?.data?.components
    ? typedRaw.data
    : typedRaw;

  const dataNode: DataNode | undefined = root?.data?.components
    ? root?.data
    : root?.data?.data
    ? root.data.data
    : root?.data;

  const components = asComponents(dataNode?.components ?? root?.components);

  const pageData: CancelPolicyPageData =
    dataNode?.pageData ?? root?.pageData ?? {};

  const bookingId =
    root?.bookingId ??
    dataNode?.bookingId ??
    pageData.bookingId ??
    pageData.orderId ??
    "";

  return { bookingId, components, pageData };
};
